import classNames from 'classnames';

const TextInput = ({...props}: any) => {
  if (props?.multiline) {
    return (
      <textarea
        {...props}
        onChange={(e) => {
          props.onChangeText?.(e.target.value);
        }}
        className={classNames('w-full bg-transparent', props?.className)}
      />
    );
  }
  return (
    <input
      {...props}
      onChange={(e) => {
        props.onChangeText?.(e.target.value);
      }}
      className={classNames('w-full bg-transparent', props?.className)}
    />
  );
};

export default TextInput;
